var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text-right"},[_vm._v(" "+_vm._s(_vm.secToMin(Math.round(_vm.elapsed / 1000)))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }